module.exports = __webpack_public_path__ + "img/protection_skincover_advance.4c0dd0f0.jpg";